var _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _path7, _circle3, _path8, _path9, _path10, _circle4, _path11, _circle5, _path12, _path13, _path14, _circle6, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "stakeholder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a79ba7",
    fillRule: "evenodd",
    d: "M421.122 375.246a7.981 7.981 0 0 1-8 13.812l-149.153-86.114-.001 181.8a7.97 7.97 0 0 1-15.938 0l.001-181.818-149.184 86.133a7.966 7.966 0 0 1-7.937-13.813l149.144-86.108-149.145-85.875a7.967 7.967 0 0 1 7.937-13.813l149.185 85.898-.001-131.046a7.97 7.97 0 0 1 15.938 0l.001 131.046 149.185-85.899a7.966 7.966 0 0 1 7.937 13.813l-149.128 85.866 149.159 86.118z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe177",
    fillRule: "evenodd",
    d: "M94.878 164.856c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5-31.5-14.103-31.5-31.5 14.103-31.5 31.5-31.5zm322.244 0c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5-31.5-14.103-31.5-31.5 14.103-31.5 31.5-31.5zM256 441.001c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5-31.5-14.103-31.5-31.5 14.103-31.5 31.5-31.5z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    fillRule: "evenodd",
    d: "M94.878 164.856c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5c-1.702 0-3.372-.137-5-.396 15.021-2.396 26.5-15.408 26.5-31.104 0-15.695-11.479-28.708-26.5-31.103a31.688 31.688 0 0 1 5-.397zm322.244 0c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5c-1.702 0-3.371-.137-5-.396 15.02-2.396 26.5-15.408 26.5-31.104 0-15.695-11.479-28.708-26.5-31.103a31.697 31.697 0 0 1 5-.397zM256 441.001c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5c-1.702 0-3.371-.137-5-.397 15.02-2.396 26.5-15.408 26.5-31.103 0-15.695-11.479-28.708-26.5-31.103a31.697 31.697 0 0 1 5-.397z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 417.122,
    cy: 382.152,
    r: 86.88,
    fill: "#837683",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#685e68",
    fillRule: "evenodd",
    d: "M488.556 382.152c0 17.772-5.336 34.298-14.494 48.063a87.357 87.357 0 0 1-12.223 14.616c-13.872 13.319-32.156 22.077-52.441 23.863a88.037 88.037 0 0 0 21.723-.783C472.447 461.216 504 425.369 504 382.153c0-47.983-38.897-86.88-86.88-86.88a87.65 87.65 0 0 0-7.723.339c44.367 3.906 79.159 41.16 79.159 86.54z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ac9fe",
    fillRule: "evenodd",
    d: "M417.122 390.531c-31.297 0-57.062 23.714-60.326 54.144 15.627 15.081 36.893 24.357 60.325 24.357 4.222 0 8.373-.301 12.433-.883 18.477-2.648 35.077-11.113 47.888-23.477-3.257-30.436-29.019-54.141-60.32-54.141z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#60b7ff",
    fillRule: "evenodd",
    d: "M409.401 391.018c36.115 4.589 50.668 31.916 54.014 64.664a87.352 87.352 0 0 0 14.029-11.009c-3.258-30.436-29.02-54.141-60.321-54.141a60.918 60.918 0 0 0-7.722.486z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.123,
    cy: 355.269,
    r: 30.675,
    fill: "#f6dccd",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cbbc",
    fillRule: "evenodd",
    d: "M440.075 355.269c0 15.634-11.695 28.536-26.814 30.434 1.265.159 2.554.241 3.861.241 16.942 0 30.675-13.734 30.675-30.675 0-16.941-13.734-30.675-30.675-30.675-1.308 0-2.596.082-3.861.241 15.119 1.899 26.814 14.801 26.814 30.434z",
    clipRule: "evenodd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 94.879,
    r: 86.88,
    fill: "#837683",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#685e68",
    fillRule: "evenodd",
    d: "M327.434 94.879c0 17.772-5.336 34.298-14.494 48.063a87.357 87.357 0 0 1-12.223 14.616c-13.872 13.319-32.156 22.077-52.441 23.863a88.037 88.037 0 0 0 21.723-.783c41.326-6.695 72.879-42.541 72.879-85.758 0-47.983-38.897-86.88-86.88-86.88-2.602 0-5.179.114-7.723.338 44.367 3.907 79.159 41.161 79.159 86.541z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ac9fe",
    fillRule: "evenodd",
    d: "M256 103.257c-31.296 0-57.062 23.714-60.326 54.144 15.627 15.081 36.893 24.357 60.325 24.357 4.222 0 8.373-.301 12.433-.883 18.477-2.648 35.077-11.113 47.888-23.477-3.257-30.435-29.019-54.141-60.32-54.141z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#60b7ff",
    fillRule: "evenodd",
    d: "M248.278 103.744c36.115 4.589 50.668 31.916 54.014 64.664a87.352 87.352 0 0 0 14.029-11.009c-3.258-30.437-29.02-54.142-60.321-54.142-2.616 0-5.193.166-7.722.487z",
    clipRule: "evenodd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.001,
    cy: 67.996,
    r: 30.675,
    fill: "#f6dccd",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cbbc",
    fillRule: "evenodd",
    d: "M278.953 67.996c0 15.634-11.695 28.536-26.814 30.434 1.265.159 2.554.241 3.861.241 16.941 0 30.675-13.734 30.675-30.675 0-16.941-13.734-30.675-30.675-30.675a30.93 30.93 0 0 0-3.861.241c15.119 1.898 26.814 14.801 26.814 30.434z",
    clipRule: "evenodd"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.878,
    cy: 382.152,
    r: 86.88,
    fill: "#837683",
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "rotate(-16.843 94.886 382.13)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#685e68",
    fillRule: "evenodd",
    d: "M166.312 382.152c0 17.772-5.336 34.298-14.494 48.063a87.357 87.357 0 0 1-12.223 14.616c-13.872 13.319-32.156 22.077-52.441 23.863a88.054 88.054 0 0 0 21.723-.783c41.326-6.695 72.879-42.542 72.879-85.758 0-47.983-38.897-86.88-86.88-86.88a87.65 87.65 0 0 0-7.723.339c44.367 3.906 79.159 41.16 79.159 86.54z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ac9fe",
    fillRule: "evenodd",
    d: "M94.878 390.531c-31.296 0-57.062 23.714-60.326 54.144 15.627 15.081 36.893 24.357 60.325 24.357 4.222 0 8.373-.301 12.433-.883 18.477-2.648 35.077-11.113 47.888-23.477-3.257-30.436-29.019-54.141-60.32-54.141z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#60b7ff",
    fillRule: "evenodd",
    d: "M87.156 391.018c36.115 4.589 50.668 31.916 54.014 64.664a87.352 87.352 0 0 0 14.029-11.009c-3.258-30.436-29.02-54.141-60.321-54.141a60.93 60.93 0 0 0-7.722.486z",
    clipRule: "evenodd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.878,
    cy: 355.269,
    r: 30.675,
    fill: "#f6dccd",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cbbc",
    fillRule: "evenodd",
    d: "M117.831 355.269c0 15.634-11.695 28.536-26.814 30.434 1.265.159 2.554.241 3.861.241 16.942 0 30.675-13.734 30.675-30.675 0-16.941-13.734-30.675-30.675-30.675-1.308 0-2.596.082-3.861.241 15.118 1.899 26.814 14.801 26.814 30.434z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/networking.5aa507ef04beb3a5cc6ad0bc1f699f4f.svg";
export { ForwardRef as ReactComponent };